import * as React from "react"
import type { SVGProps } from "react"
const SvgRecList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.5 8.93a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29zm-.71 3.71q.29.3.71.29h10q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3h-10a1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .44.29.72m0 4q.29.3.71.29h6q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3h-6a1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .44.29.72m10.16 3.79a1 1 0 0 1-.67-.28 1 1 0 0 1-.28-.67v-2.85q0-.14.06-.27l.15-.22 1.5-1.5a.7.7 0 0 1 .5-.21q.3 0 .53.24.22.23.17.6l-.16.89h2.47q.2 0 .34.14.13.14.13.33v.6l-.05.26L18.58 20a1 1 0 0 1-.27.32 1 1 0 0 1-.4.1z" />
  </svg>
)
export default SvgRecList
